import React from "react";
import styled from "styled-components";
import { PodSettings } from "../assets/Podcast/PodSettings";
import { PodDash } from "../assets/Podcast/PodDash";
import { PodEpisodes } from "../assets/Podcast/PodEpisodes";
import MainLayoutV3 from "../components/Layouts/MainLayoutV3";
import { Redirect, Route, Switch } from "react-router-dom";
import { PodAnalytics } from "../assets/Podcast/PodAnalytics";
import WorkPageDashboard from "./Work/WorkPageDashboard";
import WorkPageResume from "./Work/WorkPageResume";
import WorkPageJobs from "./Work/WorkPageJobs";
import WorkPageEditResume from "./Work/WorkPageEditResume";
import WorkPagePayroll from "./Work/WorkPagePayroll";
import WorkPageDocuments from "./Work/WorkPageDocuments";
import WorkPageAccounts from "./Work/WorkPageAccounts";
import WorkPageContracts from "./Work/WorkPageContracts";
import PersonalData from "./Profile/PersonalData";
import { UserProfile } from "../assets/User/UserProfile";
import { PodMoney } from "../assets/Podcast/PodMoney";
import { PodCards } from "../assets/Podcast/PodCards";
import { PodRecipet } from "../assets/Podcast/PodRecipet";
import { PodFolder } from "../assets/Podcast/PodFolder";
import { PodCopy } from "../assets/Podcast/PodCopy";
import { PodResume } from "../assets/Podcast/PodResume";
import WorkPagePayrollSingle from "./Work/WorkPagePayrollSingle";
import { PodCredit } from "../assets/Podcast/PodCredit";
import WorkPageCredit from "./Work/WorkPageCredit";
import WorkPageCreditEdit from "./Work/WorkPageCreditEdit";
import { PodExam } from "../assets/Podcast/PodExam";
import WorkPageExams from "./Work/WorkPageExams";
import WorkPageExamPage from "./Work/WorkPageExamPage";
import WorkPageCompliance from "./Work/WorkPageCompliance";

const StyleCss = styled.div`
  .main-box{
    background-color: var(--n-body-2);
    min-height: 70vh;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    color: var(--n-grey-9);
    .title-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1.5rem;
      border-bottom: 1px solid var(--n-grey-3);
      gap: 1rem;
      .expand {
        flex-grow: 1;
      }
      .title {
        display: flex;
        align-items: center;
        .icon {
          padding: 12px 0;
          svg {
            width: 32px;
            height: 32px;
            display: block;
            fill: var(--n-grey-9);
          }
          .stroke {
            fill: none;
            stroke: var(--n-grey-9);
          }
        }
        .text {
          margin: 0rem 0.5rem;
          font-size: 22px;
          font-weight: 600;
          padding: 12px 0 6px;
          height: 32px;
        }
      }
      .action {
        cursor: pointer;
        padding: 12px;
        border: 1px solid var(--n-grey-3);
        background-color: var(--n-grey-1);
        border-radius: 8px;
        svg {
          display: block;
          fill: var(--n-grey-7);
        }
      }
    }
  }
  .commingsoon {
    position: absolute;
    top: 100px;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 400px;
    font-size: 20px;
    font-weight: 700;
  }
`;


let menuItems = [
    {
        icon: <PodDash/>,
        title: 'Dashboard',
        link: 'dashboard'
    },
    {
      icon: <UserProfile/>,
      title: 'Personal info',
      link: 'personal-data'
    },
    {
      icon: <PodFolder/>,
      title: 'Compliance',
      link: 'compliance'
    },
    {
      icon: <PodResume/>,
      title: 'Resume',
      link: 'resume'
    },
    {
      icon: <PodExam/>,
      title: 'Exams',
      link: 'exams'
    },
    {
      icon: <PodRecipet/>,
      title: 'Payroll',
      link: 'payroll'
    },
    // {
    //   icon: <PodFolder/>,
    //   title: 'Contracts',
    //   link: 'contracts'
    // },
    {
      icon: <PodCopy/>,
      title: 'Documents',
      link: 'documents'
    },
    {
      icon: <PodCards/>,
      title: 'Bank Accounts',
      link: 'baccounts'
    },
    // {
    //   icon: <PodCredit/>,
    //   title: 'Shopping Credit',
    //   link: 'credit'
    // },
    
]



// get main podcast data and routes in menu
function WorkPage(propsMain) {
  return (
    <MainLayoutV3 {...propsMain} type={''} base={'/work'} menu={menuItems} image={''} name={propsMain.userdata.FName + ' ' + propsMain.userdata.LName} userBalance={0}>
      <StyleCss>
      <Switch>
          <Route 
            exact
            path={`/work/dashboard`}
            render={(props) => (
              <WorkPageDashboard 
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/personal-data`}
            render={(props) => (
              <PersonalData {...propsMain} {...props}/>
            )}/>
          <Route 
            exact
            path={`/work/personal-data/:edit`}
            render={(props) => (
              <PersonalData {...propsMain} {...props}/>
            )}/>
          <Route 
            exact
            path={`/work/exams`}
            render={(props) => (
              <WorkPageExams
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/exams/:_id`}
            render={(props) => (
              <WorkPageExamPage
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/resume`}
            render={(props) => (
              <WorkPageResume 
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/resume/:edit`}
            render={(props) => (
              <WorkPageResume 
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/addnewresume`}
            render={(props) => (
              <WorkPageEditResume 
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/addnewresume/:stage`}
            render={(props) => (
              <WorkPageEditResume 
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/addnewresume/:stage/:id`}
            render={(props) => (
              <WorkPageEditResume 
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/documents`}
            render={(props) => (
              <WorkPageDocuments 
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/baccounts`}
            render={(props) => (
              <WorkPageAccounts 
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/jobs`}
            render={(props) => (
              <WorkPageJobs
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/contracts`}
            render={(props) => (
              <WorkPageContracts
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/compliance`}
            render={(props) => (
              <WorkPageCompliance
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/payroll`}
            render={(props) => (
              <WorkPagePayroll
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/payroll/:id`}
            render={(props) => (
              <WorkPagePayrollSingle
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/credit`}
            render={(props) => (
              <WorkPageCredit
                {...propsMain}
                {...props}
              />
            )}/>
          <Route 
            exact
            path={`/work/credit/:id`}
            render={(props) => (
              <WorkPageCreditEdit
                {...propsMain}
                {...props}
              />
            )}/>
          <Route render={(props) => <Redirect to={'/work/dashboard'} />} />
        </Switch>
      </StyleCss>
    </MainLayoutV3>
  );
}

export default WorkPage;
